import React from 'react';

export default function ProjectsSection() {
  const projectCategories = [
    {
      category: 'Software & Web Development',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"/>
          <polyline points="8 6 2 12 8 18"/>
          <line x1="14" y1="4" x2="10" y2="20"/>
        </svg>
      ),
      projects: [
        { name: 'Games of Engineers', description: 'An interactive collection of engineering-themed games designed to make technical concepts fun and engaging.', tags: 'Game Dev, Engineering' },
        { name: 'Resto Website', description: 'A modern restaurant website with menu browsing, online ordering features, and a responsive, user-friendly design.', tags: 'Web Dev, React' },
        { name: 'MicroLab Inventory Management System', description: 'A comprehensive inventory tracking system for laboratory equipment and microelectronics components.', tags: 'Full-Stack, Database' }
      ]
    },
    {
      category: 'Computer Vision & AI',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      ),
      projects: [
        { name: 'EyeAware: Adaptive Eye Detection System', description: 'An intelligent system that detects and tracks eye movement in real time, adapting to varying lighting conditions and user positions.', tags: 'Computer Vision, Python' },
        { name: 'AttriSense: From Attrition to Retention', description: 'A data-driven analytics tool that predicts employee attrition and provides actionable insights to improve retention strategies.', tags: 'Data Science, ML' }
      ]
    },
    {
      category: 'Robotics & Embedded Systems',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="2" ry="2"/>
          <rect x="9" y="9" width="6" height="6"/>
          <line x1="9" y1="1" x2="9" y2="4"/>
          <line x1="15" y1="1" x2="15" y2="4"/>
          <line x1="9" y1="20" x2="9" y2="23"/>
          <line x1="15" y1="20" x2="15" y2="23"/>
          <line x1="20" y1="9" x2="23" y2="9"/>
          <line x1="20" y1="14" x2="23" y2="14"/>
          <line x1="1" y1="9" x2="4" y2="9"/>
          <line x1="1" y1="14" x2="4" y2="14"/>
        </svg>
      ),
      projects: [
        { name: 'Line Following Robot', description: 'An autonomous robot that detects and follows a path using infrared sensors and real-time motor control.', tags: 'Robotics, Arduino' },
        { name: 'Sumo Bot', description: 'A competitive sumo robot engineered to detect opponents and push them out of the ring using strategic movement algorithms.', tags: 'Robotics, Competition' },
        { name: 'Smart Room Lock System', description: 'An IoT-enabled smart lock providing keyless room access through digital authentication and remote control.', tags: 'IoT, Embedded' },
        { name: 'Ambient Light-Based Smart Lighting System', description: 'A smart lighting system that automatically adjusts brightness based on ambient light levels for energy efficiency and comfort.', tags: 'IoT, Sensors' }
      ]
    },
    {
      category: 'FPGA & Hardware Design',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
          <line x1="6" y1="6" x2="6.01" y2="6"/>
          <line x1="6" y1="18" x2="6.01" y2="18"/>
        </svg>
      ),
      projects: [
        { name: 'Elevator System on FPGA', description: 'A hardware-level elevator control system implemented on an FPGA using finite state machines for floor management and scheduling.', tags: 'FPGA, VHDL' },
        { name: 'Tetris on FPGA', description: 'A fully playable Tetris game implemented in hardware on an FPGA, featuring VGA display output and real-time user input.', tags: 'FPGA, Game Dev' },
        { name: 'Secure Digital Lock System with Alarm', description: 'Design and verification of a secure digital lock with alarm functionality, validated through simulation-driven assertion-based verification.', tags: 'HDL, Verification' },
        { name: '2 Digit Decimal Counter PCB Layout', description: 'A PCB design for a two-digit decimal counter circuit, from schematic capture to board layout and fabrication.', tags: 'PCB Design, Electronics' }
      ]
    },
    {
      category: 'Mathematical & Scientific Computing',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
      projects: [
        { name: "Pascal's Triangle Code Implementation", description: 'A Python implementation of Pascal\'s Triangle showcasing mathematical pattern generation and algorithm design.', tags: 'Python, Algorithms' },
        { name: '3D Heat Conduction on Metal Plates', description: 'Application of Partial Differential Equations to simulate and visualize 3D heat distribution across metal plate surfaces.', tags: 'PDE, Simulation, Math' },
        { name: 'VizMath (Calculus Calculator)', description: 'An interactive calculus calculator that solves derivatives, integrals, and visualizes mathematical functions graphically.', tags: 'Math, Python' }
      ]
    },
    {
      category: 'Assistive Technology & Navigation',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
        </svg>
      ),
      projects: [
        { name: 'PaNORTH (Navigation System)', description: 'A custom navigation system providing location tracking, route optimization, and real-time directional guidance.', tags: 'Navigation, GPS' },
        { name: 'Third-Eye (Visually Impaired Assistant)', description: 'An assistive device for visually impaired individuals that uses sensors and audio feedback to help navigate surroundings safely.', tags: 'Accessibility, IoT' },
        { name: 'Sonic Clarity', description: 'An audio processing application focused on enhancing sound quality and clarity for improved listening experiences.', tags: 'Audio, Signal Processing' }
      ]
    }
  ];

  return (
    <section id="projects" className="section section-alt">
      <div className="section-content">
        <h2 className="section-title">Projects</h2>
        <p style={{ marginBottom: '3rem', fontSize: '1.05rem', opacity: '0.9', maxWidth: '800px' }}>
          A diverse collection of projects spanning software development, embedded systems, robotics, FPGA design, and data science — showcasing hands-on experience across the full spectrum of computer engineering.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '3rem' }}>
          {projectCategories.map((category, index) => (
            <div 
              key={index}
              className="glass-card"
              style={{ 
                padding: '0',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                transition: 'all 0.3s ease',
                position: 'relative'
              }}
            >
              {/* Left Panel - Icon */}
              <div style={{ 
                flex: '0 0 340px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.06) 100%)',
                borderRight: '1px solid var(--glass-border)',
                padding: '3rem 2rem',
                position: 'relative'
              }}>
                {/* Vertical Accent Bar */}
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: '20%',
                  bottom: '20%',
                  width: '5px',
                  background: 'var(--primary)',
                  borderRadius: '0 4px 4px 0',
                  boxShadow: '0 0 20px var(--primary)'
                }}></div>

                {/* Icon Container */}
                <div style={{
                  width: '160px',
                  height: '160px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '20px',
                  border: '2px solid var(--glass-border)',
                  padding: '2rem',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                  color: 'var(--primary)'
                }}>
                  {category.icon}
                </div>
              </div>

              {/* Right Panel - Projects */}
              <div style={{ 
                flex: '1',
                padding: '3rem 3.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.15)',
                minHeight: '300px'
              }}>
                {/* Category Title */}
                <div style={{ marginBottom: '2.5rem' }}>
                  <h3 style={{ 
                    fontSize: '1.75rem', 
                    marginBottom: '1rem',
                    color: 'var(--text)',
                    lineHeight: '1.3',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    {category.category}
                  </h3>
                </div>

                {/* Projects List */}
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1.5rem'
                }}>
                  {category.projects.map((project, idx) => (
                    <div 
                      key={idx} 
                      style={{ 
                        display: 'flex',
                        gap: '1rem',
                        alignItems: 'flex-start',
                        padding: '1rem 1.25rem',
                        background: 'rgba(255, 255, 255, 0.03)',
                        borderRadius: '10px',
                        border: '1px solid var(--glass-border)',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                        e.currentTarget.style.borderColor = 'var(--primary)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                        e.currentTarget.style.borderColor = 'var(--glass-border)';
                      }}
                    >
                      {/* Icon Indicator */}
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'var(--primary)',
                        marginTop: '8px',
                        flexShrink: 0,
                        boxShadow: '0 0 10px var(--primary)'
                      }}></div>
                      
                      <div style={{ flex: 1 }}>
                        <span style={{ 
                          color: 'var(--primary)', 
                          fontWeight: '700',
                          fontSize: '0.8rem',
                          textTransform: 'uppercase',
                          letterSpacing: '1.2px',
                          display: 'block',
                          marginBottom: '0.5rem'
                        }}>
                          {project.name}
                        </span>
                        <span style={{ 
                          color: 'var(--muted)', 
                          fontSize: '1rem',
                          lineHeight: '1.7',
                          display: 'block',
                          marginBottom: '0.5rem'
                        }}>
                          {project.description}
                        </span>
                        <span style={{
                          color: 'var(--primary)',
                          fontSize: '0.85rem',
                          opacity: '0.7',
                          fontStyle: 'italic'
                        }}>
                          {project.tags}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Responsive Styles */}
        <style>{`
          @media (max-width: 1024px) {
            .glass-card > div:first-child {
              flex: 0 0 100% !important;
              border-right: none !important;
              border-bottom: 1px solid var(--glass-border) !important;
              padding: 2.5rem 2rem !important;
            }
            .glass-card > div:last-child {
              padding: 2.5rem 2rem !important;
            }
            .glass-card {
              flex-direction: column !important;
            }
          }
        `}</style>

      </div>
    </section>
  );
}
